@if (toast(); as t) {
    <div class="toast-wrapper">
        <div
            class="toast"
            [ngClass]="typeClass()"
            [attr.role]="
                t.type === 'error' || t.type === 'warning' ? 'alert' : 'status'
            "
            [attr.aria-live]="
                t.type === 'error' || t.type === 'warning'
                    ? 'assertive'
                    : 'polite'
            "
        >
            <div class="toast__icon">
                @switch (t.type) {
                    @case ('success') {
                        <i class="fa-solid fa-circle-check"></i>
                    }
                    @case ('error') {
                        <i class="fa-solid fa-circle-xmark"></i>
                    }
                    @case ('warning') {
                        <i class="fa-solid fa-triangle-exclamation"></i>
                    }
                    @default {
                        <i class="fa-solid fa-circle-info"></i>
                    }
                }
            </div>
            <span class="toast__message">{{ t.message }}</span>
            <button class="toast__close" type="button" (click)="onCloseClick()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
    </div>
}
